import React from 'react';

// Filter by ICD-10 tagging state (pending / tagged / frame-plano)
const IcdStatusFilter = ({ onChange, currentFilter }) => {
  const handleChange = (event) => {
    const value = event.target.value;
    const filterValue = value === '' ? null : value;
    onChange(filterValue);
  };

  return (
    <select
      onChange={handleChange}
      style={{
        width: '100%',
        height: '40px',
        fontSize: '12px',
        borderRadius: '10px',
      }}
      value={currentFilter || ''}
    >
      <option value="">All</option>
      <option value="pending">ICD Pending</option>
      <option value="tagged">ICD Tagged</option>
      <option value="frame-plano">Frame/Plano</option>
    </select>
  );
};

export default IcdStatusFilter;
